<template>
  <v-row>
    <v-dialog v-model="showDialog" max-width="500px" style="z-index: 1021;">
      <v-card>
        <v-card-title>
          <v-panel>
              <span style="font-size: 20px">
                {{ getEmployeeFullname(employee) }}
              </span>
          </v-panel>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form">
              <v-row align="center">
                <v-col cols="12">
                  <v-text-field
                    v-model="dedication"
                    :label="$t('wkt.admin.projects.project.table.headers.dedication')"
                    :rules="[validationRules.decimalSeparator, validationRules.isValidRange]"
                    type="text"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#185EA9" text @click="onSave()" style="font-size: 0.9em; font-weight: 400">
            {{ $t("wkt.admin.common.dialog-buttons.save").toUpperCase() }}
          </v-btn>
          <v-btn text @click="showDialog = false" style="font-size: 0.9em; font-weight: 400">
            {{ $t("wkt.admin.common.dialog-buttons.cancel").toUpperCase() }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import BaseModule from "../../common/BaseModule.js";

export default {
  name: "EditProjectEmployeeDialog",
  mixins: [BaseModule],
  components: {
  },
  data() {
    return {
      showDialog: false,
      employee: null,
      dedication: null,
      msgCb: null,
    };
  },
  methods: {
    open(employee, msgCb) {
      this.employee = employee;
      this.msgCb = msgCb;
      this.dedication = this.employee.dedication ? this.employee.dedication: 0;
      this.showDialog = true;
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    onSave() {
      if (!this.$refs.form.validate()) {
        return;
      }

			/*if (!gwt.validateRange(this.dedication, 0, 100)) {
        this.errorMessages = `${this.$t('wkt.admin.common.validation-utils.required_field')} [ 0 - 100 ]`;
				return;
			}*/

      const dedication = parseFloat(this.dedication.toString().replace(',', '.'));
      
      if (this.msgCb) {
        this.msgCb(dedication);
      }
  
      this.showDialog = false;
    }
  }
}
</script>